import React, { useEffect, useState } from "react";
import {
    Input,
    Form,
    Select,
    Row,
    Col,
    Spin,
    Tooltip,
    Image,
} from "antd";

import {
    QuestionCircleOutlined,
    DeleteOutlined,
} from "@ant-design/icons";
import UserIcon from "../../../../../../assets/images/icons/userLogo.svg";
import { useLocation } from "react-router-dom";
import { useStore } from "../../../../../../store";
import { aboutUSkeys } from "../../../../../../config";
import { useTab } from "../../../../../../custom-hooks/useTab";
import { useConnectsuForm } from "../../../../../../custom-hooks/useConnectsuForm";
import { getFormFieldValue } from "../../../../../../utils";
import ReactPlayer from "react-player/youtube";
import SynthesiaVideo from "../../SynthesiaVideo";
import {
    DragAndDropList,
    GifCreator,
    GifResultPreview,
    createEmptyGifState,
    hydrateGifCreatorState,
} from "../../../../../../components/common";
import './AboutUs.scss'


const { TextArea } = Input;
const MAX_CHARACTERS = 2000;

// ---- NEW GIF implementation (same approach as WhyWorkForUs.jsx) ----
const withGifDefaults = (rows) => {
    if (!Array.isArray(rows)) return rows;
    return rows.map((row) => {
        if (row?.mediaLink?.mediaType === "GIF") {
            return {
                ...row,
                mediaLink: {
                    ...row.mediaLink,
                    gifCreator: hydrateGifCreatorState(row.mediaLink),
                },
            };
        }
        return row;
    });
};



export default function AboutUsComponent({
    dataLoader,
    form,
    handleTabs,
    activeKey,
}) {
    const { state } = useLocation();
    const tabKey = state;
    const { tabData } = useStore();
    const whichTab = aboutUSkeys.About;
    const { deleteSingleItem, postLoader } = useTab();
    const { updateImage } = useConnectsuForm();
    const [loader, setLoader] = useState(true);
    const [, setFormChanged] = useState(false);
    const { updatedValues } = useStore();

    if (activeKey === "ABOUT_US") {
        localStorage.setItem("tab", activeKey);
    }

    useEffect(() => {
        setFormChanged(false);
    }, []);


    useEffect(() => {
        const isNotEmpty = Object.keys(updatedValues).length > 0;

        setFormChanged(isNotEmpty);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [Object.keys(updatedValues).length]);

    const renderMedia = (dataItem, rowIndex) => {
        const commonStyles = {
            display: "flex",
            justifyContent: "center",
        };

        if (
            dataItem?.mediaLink?.mediaType === "SOCIAL_MEDIA" &&
            dataItem.mediaLink.url
        ) {
            return (
                <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
                    <ReactPlayer
                        controls={true}
                        url={dataItem.mediaLink.url}
                        width="100%"
                        height="100%"
                    />
                </div>
            );
        } else if (
            dataItem?.mediaLink?.mediaType === "VIMEO_MEDIA" &&
            dataItem.mediaLink.url
        ) {
            return (
                <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
                    <iframe
                        title="Embedded video"
                        src={dataItem.mediaLink.url}
                        frameBorder="0"
                        allow="autoplay; fullscreen; picture-in-picture"
                        allowFullScreen
                        style={{ backgroundColor: "black" }}
                    />
                </div>
            );
        } else if (
            dataItem?.mediaLink?.mediaType === "IMAGE" &&
            dataItem.mediaLink.url
        ) {
            return (
                <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
                    <img
                        src={dataItem?.mediaLink?.url}
                        alt=""
                        className="c1 carousel-image"
                        style={{ maxWidth: "100%", maxHeight: "100%" }}
                    />
                </div>
            );
        }
        else if (
            dataItem?.mediaLink?.mediaType === "GIF"
        ) {
            const gifState = dataItem.mediaLink.gifCreator || {};
            const gifUrl = gifState.previewUrl || dataItem.mediaLink.url;
            return (
                <GifResultPreview
                    url={gifUrl}
                    fileName={gifState.fileName}
                    loading={!!gifState.generating}
                    showEdit={!!gifUrl && gifState.isEditing === false}
                    onEdit={() => {
                        const current = form.getFieldValue([
                            whichTab,
                            rowIndex,
                            "mediaLink",
                            "gifCreator",
                        ]);
                        form.setFieldValue(
                            [whichTab, rowIndex, "mediaLink", "gifCreator"],
                            { ...createEmptyGifState(), ...current, isEditing: true }
                        );
                    }}
                />
            );
        }
        /* OLD GIF preview: GifRenderedMedia when mediaLink.url was present. */
        else if (
            dataItem?.mediaLink?.mediaType === "SYNTHESIA_MEDIA" &&
            dataItem.mediaLink.url) {
            return (
                <div className={`iframe-comp ${dataItem?.mediaLink?.mediaType}`} style={commonStyles}>
                    <SynthesiaVideo key={dataItem.id} videoData={dataItem} />

                </div>
            )
        }

        return null;
    };

    const findValue = (i, key) => {
        return getFormFieldValue(form, whichTab, i, key);
    };

    const MakeFieldDisableHandler = (i) => {
        let value = form.getFieldValue([whichTab, i, "title"]);
        if (value === "WhyDo" || value === "howDo" || value === "whatDo") {
            return true;
        }
    };

    const handleAboutUsLabel = (i) => {
        let value = form.getFieldValue([whichTab, i, "title"]);
        if (value === "WhyDo") {
            return "Why";
        } else if (value === "howDo") {
            return "How";
        } else if (value === "whatDo") {
            return "What we do";
        } else {
            return "About Us";
        }

    }

    const ShowCustomTitleHandler = (i) => {
        const value = form?.getFieldValue([whichTab, i, "title"])?.trim()?.toLowerCase();
        const titles = {
            whydo: "Why we exist",
            howdo: "How we help",
            whatdo: "What we do",
        };

        return titles[value] || "";
    };

    const SelectChangeHandler = (e, i) => {
        form.setFieldValue([whichTab, i, "mediaLink", "url"], "");
        if (e === "GIF") {
            form.setFieldValue(
                [whichTab, i, "mediaLink", "gifCreator"],
                createEmptyGifState()
            );
        } else {
            form.setFieldValue([whichTab, i, "mediaLink", "gifCreator"], undefined);
        }
    };

    useEffect(() => {
        form.resetFields();
        if (tabData && tabData[whichTab] && tabData[whichTab].length > 0) {
            form.setFieldsValue({
                [whichTab]: withGifDefaults(tabData[whichTab]),
            });
        }

        setTimeout(() => {
            setLoader(false);
        }, 1000);
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [tabData[whichTab]]);

    if (dataLoader || postLoader || loader) {
        return (
            <div className="data-loader">
                <Spin tip="Loading" size="large" />
            </div>
        );
    } else {
        return (
            <div className="newContantStyle">
                {/* scoped styles for the gif thumbnail grid + hover-to-delete */}
                <style>{`
                    .gif-hint-row { display: flex; align-items: center; gap: 8px; margin-bottom: 8px; }
                    .gif-thumb-list { display: flex; flex-wrap: wrap; gap: 10px; margin-bottom: 12px; align-items: center; }
                    .gif-thumb-item { position: relative; width: 90px; height: 90px; border-radius: 8px; overflow: hidden; border: 1px solid #d9d9d9; }
                    .gif-thumb-item .ant-image { width: 100%; height: 100%; display: block; }
                    .gif-thumb-img { width: 100%; height: 100%; object-fit: cover; display: block; }
                    .gif-thumb-delete {
                        position: absolute; top: 4px; right: 4px; z-index: 5;
                        width: 20px; height: 20px; display: flex; align-items: center; justify-content: center;
                        border-radius: 50%; background: rgba(0, 0, 0, 0.6); color: #fff; font-size: 11px; cursor: pointer;
                        opacity: 0; transition: opacity 0.2s ease;
                    }
                    .gif-thumb-item:hover .gif-thumb-delete { opacity: 1; }
                    .gif-thumb-delete:hover { background: #ff4d4f; }
                    .gif-hint { margin-bottom: 0; color: rgba(0, 0, 0, 0.45); }
                    .gif-upload-tile {
                        position: relative;
                        width: 90px; height: 90px; border-radius: 8px; box-sizing: border-box;
                        border: 1px dashed #CC0E2D; background: #ffffff; color: #CC0E2D;
                        display: flex; flex-direction: column; align-items: center; justify-content: center;
                        gap: 6px; cursor: pointer; margin: 0; overflow: hidden;
                    }
                    .gif-upload-tile:hover { border-color: #a30b24; background: #fff5f6; color: #a30b24; }
                    .gif-upload-tile-input,
                    .gif-upload-tile input[type="file"] {
                        display: none !important;
                        visibility: hidden !important;
                        opacity: 0 !important;
                        position: absolute !important;
                        width: 0 !important;
                        height: 0 !important;
                        pointer-events: none !important;
                    }
                    .gif-upload-tile-icon { font-size: 22px; color: #CC0E2D; }
                    .gif-upload-tile-text { font-size: 12px; font-weight: 600; color: #CC0E2D; line-height: 1; }
                    .gif-upload-tile:hover .gif-upload-tile-icon,
                    .gif-upload-tile:hover .gif-upload-tile-text { color: #a30b24; }
                `}</style>
                <Row className="rowBody" gutter={{ xs: 8, sm: 16, md: 24, lg: 32 }}>
                    {(tabKey.split('/')[1] === whichTab || tabKey === 'about-us') ? (
                        <>
                            <Col className="gutter-row tabContent" span={24}>
                                <>
                                    <Form.List
                                        name={whichTab}
                                        initialValue={
                                            tabData &&
                                                tabData[whichTab] &&
                                                tabData[whichTab].length > 0
                                                ? withGifDefaults((tabData[whichTab]))
                                                : [{ title: 'WhyDo' }, { title: 'howDo' }, { title: 'whatDo' }]
                                        }
                                    >
                                        {(fields, { add, remove, move }) => {
                                            return (
                                                <DragAndDropList
                                                    enabled={false}
                                                    fields={fields}
                                                    move={move}
                                                    form={form}
                                                    fieldName={whichTab}
                                                    renderItem={({ key, name, ...restField }, i) => (
                                                        <div className="card-item">
                                                            <Col
                                                                className="gutter-row tabContent"
                                                                xs={24}
                                                                sm={24}
                                                                md={14}
                                                                lg={14}
                                                                style={{ paddingRight: "25px" }}
                                                            >
                                                                <div className="d-flex">
                                                                    {MakeFieldDisableHandler(i) && (
                                                                        <Form.Item
                                                                            {...restField}
                                                                            className="custom-work"
                                                                            label={handleAboutUsLabel(i)}
                                                                            labelCol={{ span: 5 }}
                                                                            name={[name, "title"]}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <label className="work-title">
                                                                                {ShowCustomTitleHandler(i)}
                                                                            </label>
                                                                        </Form.Item>
                                                                    )}
                                                                    {!MakeFieldDisableHandler(i) && (
                                                                        <Form.Item
                                                                            {...restField}
                                                                            className="custom-work"
                                                                            label="About Us"
                                                                            labelCol={{ span: 5 }}
                                                                            name={[name, "title"]}
                                                                            rules={[
                                                                                {
                                                                                    required: true,
                                                                                    message: "Title is required",
                                                                                },
                                                                            ]}
                                                                        >
                                                                            <Input placeholder="Enter title" />
                                                                        </Form.Item>
                                                                    )}

                                                                    <Form.Item>
                                                                        {fields.length > 1 &&
                                                                            i !== 0 &&
                                                                            findValue(i, "id") &&
                                                                            !MakeFieldDisableHandler(i) ? (
                                                                            <div className="remove-btn">

                                                                                <DeleteOutlined
                                                                                    onClick={() =>
                                                                                        deleteSingleItem(
                                                                                            whichTab,
                                                                                            form.getFieldValue([
                                                                                                whichTab,
                                                                                                i,
                                                                                                "id",
                                                                                            ]),
                                                                                            form
                                                                                        )
                                                                                    }
                                                                                />
                                                                            </div>
                                                                        ) : null}
                                                                    </Form.Item>
                                                                </div>
                                                                <Form.Item
                                                                    {...restField}
                                                                    label="Description"
                                                                    labelCol={{ span: 5 }}
                                                                    name={[name, "description"]}
                                                                    rules={[
                                                                        {
                                                                            required: true,
                                                                            message: "Description is required",
                                                                        },
                                                                        {
                                                                            max: MAX_CHARACTERS - 1,
                                                                            message: `Description should be less than ${MAX_CHARACTERS} character`,
                                                                        }
                                                                    ]}
                                                                >
                                                                    <TextArea
                                                                        placeholder="Enter Description"
                                                                        rows={5}
                                                                        maxLength={MAX_CHARACTERS}
                                                                        showCount
                                                                        style={{ whiteSpace: "pre-wrap" }}
                                                                    />
                                                                </Form.Item>
                                                                <div className="d-flex">
                                                                    <Form.Item
                                                                        {...restField}
                                                                        className="custom-work"
                                                                        name={[name, "mediaLink", "mediaType"]}
                                                                        label="Video or Image"
                                                                        labelCol={{ span: 5 }}
                                                                    >
                                                                        <Select
                                                                            name={[name, "mediaLink", "mediaType"]}
                                                                            onChange={(e) => SelectChangeHandler(e, i)}
                                                                            placeholder="Select Option"
                                                                        >
                                                                            <Select.Option value="VIMEO_MEDIA">
                                                                                Add Vimeo Link
                                                                            </Select.Option>
                                                                            <Select.Option value="SOCIAL_MEDIA">
                                                                                Add Youtube Link
                                                                            </Select.Option>
                                                                            <Select.Option value="SYNTHESIA_MEDIA">
                                                                                Add Synthesia Link
                                                                            </Select.Option>
                                                                            <Select.Option value="IMAGE">
                                                                                Upload Image
                                                                            </Select.Option>
                                                                            {/* OLD: <Select.Option value="GIF">Upload Gif</Select.Option> */}
                                                                            <Select.Option value="GIF">
                                                                                Create GIF
                                                                            </Select.Option>
                                                                        </Select>
                                                                    </Form.Item>
                                                                    <Form.Item>
                                                                        <div className="remove-btn">
                                                                            <Tooltip
                                                                                title={
                                                                                    "Upload Video link or image with size lesser than 2.5MB. For best results, use images and videos with a 16:9 aspect ratio"
                                                                                }
                                                                            >
                                                                                <QuestionCircleOutlined />
                                                                            </Tooltip>
                                                                        </div>
                                                                    </Form.Item>
                                                                </div>
                                                                {findValue(i, "type") === "SOCIAL_MEDIA" ? (
                                                                    <Form.Item
                                                                        label="Youtube Link"
                                                                        labelCol={{ span: 5 }}
                                                                        {...restField}
                                                                        name={[name, "mediaLink", "url"]}
                                                                    >
                                                                        <Input />
                                                                    </Form.Item>
                                                                ) : findValue(i, "type") === "VIMEO_MEDIA" ? (
                                                                    <Form.Item
                                                                        label="Vimeo Link"
                                                                        labelCol={{ span: 5 }}
                                                                        {...restField}
                                                                        name={[name, "mediaLink", "url"]}

                                                                    >
                                                                        <Input />
                                                                    </Form.Item>
                                                                ) : findValue(i, "type") === "IMAGE" ? (
                                                                    <Form.Item
                                                                        {...restField}
                                                                        label="Image"
                                                                        colon={false}
                                                                        name="media"
                                                                        className="experienceImg uploadedImage "
                                                                        labelCol={{ span: 5 }}
                                                                    >
                                                                        <div>
                                                                            {findValue(i, "blob") ? (
                                                                                <Image src={URL.createObjectURL(findValue(i, "blob"))} alt="" />
                                                                            ) : findValue(i, "url") ? (
                                                                                <Image src={findValue(i, "url")} alt="" />
                                                                            ) : (
                                                                                <Image src={UserIcon} alt="" />
                                                                            )}
                                                                            <div>
                                                                                <div style={{
                                                                                    display: 'flex',
                                                                                    alignItems: 'center',
                                                                                    marginTop:'5px'
                                                                                }}>
                                                                                    <label
                                                                                        name="file"
                                                                                        className="fileUploadBtn greenBtn"
                                                                                    >
                                                                                        {" "}
                                                                                        Upload image
                                                                                        <input
                                                                                            accept="image/png, image/gif, image/jpeg"
                                                                                            type="file"
                                                                                            onChange={(e) =>
                                                                                                updateImage(e, i, form, whichTab)
                                                                                            }
                                                                                        />
                                                                                    </label>
                                                                                    <Tooltip
                                                                                        className="question"
                                                                                        title={"Recommended image dimensions: 1280x720 pixels"}
                                                                                    >
                                                                                        <QuestionCircleOutlined />
                                                                                    </Tooltip>
                                                                                </div>
                                                                                <div style={{ marginLeft: '12px', marginTop: '5px' }} className="">Add or Edit</div>
                                                                            </div>
                                                                        </div>
                                                                    </Form.Item>
                                                                ) : findValue(i, "type") === "GIF" ? (
                                                                    <Form.Item
                                                                        {...restField}
                                                                        label="Create GIF"
                                                                        colon={false}
                                                                        name={[name, "mediaLink", "gifCreator"]}
                                                                        className="gif-creator-field"
                                                                        labelCol={{ span: 5 }}
                                                                        initialValue={createEmptyGifState()}
                                                                    >
                                                                        <GifCreator />
                                                                    </Form.Item>
                                                                ) : findValue(i, "type") === "SYNTHESIA_MEDIA" ? (
                                                                    <Form.Item
                                                                        label="Synthesia Link"
                                                                        labelCol={{ span: 5 }}
                                                                        {...restField}
                                                                        name={[name, "mediaLink", "url"]}
                                                                    >
                                                                        <Input />
                                                                    </Form.Item>
                                                                ) : null}
                                                                <Form.Item
                                                                    label="External Link"
                                                                    {...restField}
                                                                    className="w-100"
                                                                    name={[name, "urlLink"]}
                                                                    labelCol={{ span: 5 }}
                                                                >
                                                                    <Input
                                                                        placeholder="External Link"
                                                                        name={[name, "urlLink"]}
                                                                    />
                                                                </Form.Item>

                                                            </Col>
                                                            <Col
                                                                className="gutter-row tabContent"
                                                                xs={24}
                                                                sm={24}
                                                                md={10}
                                                                lg={10}
                                                            >
                                                                <Form.Item shouldUpdate noStyle>
                                                                    {() => {
                                                                        const row = form.getFieldValue(whichTab)?.[i]
                                                                            || tabData?.[whichTab]?.[i];
                                                                        if (!row) return null;
                                                                        return (
                                                                            <div className="gif-container">
                                                                                {renderMedia(row, i)}
                                                                            </div>
                                                                        );
                                                                    }}
                                                                </Form.Item>
                                                            </Col>
                                                        </div>
                                                    )}
                                                />
                                            )
                                        }}
                                    </Form.List>
                                </>
                            </Col>
                        </>
                    ) : (
                        <></>
                    )}
                </Row>
            </div>
        );
    }
}
